import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const facilityUserRoutes: RouteObject[] = [
  {
    path: '/facility-users',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Facility Users',
      crumb: () => ({ label: 'Facility Users', to: '/facility-users' }),
    },
  },
  {
    path: '/facility-user/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Facility User' }) },
  },
];

export default facilityUserRoutes;
